const Legend = (props) => {
  const legendWidth = 270;
  const colourLegendWidth = 185;
  const sizeLegendWidth = legendWidth - colourLegendWidth;

//   const togglePointsHandler = (evtype) => {
//     for (const layer in evtype.current._layers) {
//         evtype.current._layers[layer].remove()
//     }
//   }

  return (
    <div
      id="legend"
      style={{
        position: "absolute",
        left: 0,
        top:props.height,
        height: 90,
        transform: "translateY(-100%)", //-105
        zIndex: 100,
        width: legendWidth,
      }}
    >
      {/* <p className="title">
        <strong>Legend</strong>
      </p> */}
      <svg
        width={sizeLegendWidth}
        //onClick={() => togglePointsHandler(props.vacPoints)}
        height={85}
        style={{
          position: "absolute",
          left: 0,
        }}
      >
        <text className="scale-legend-title" transform={"translate(7,15)"}>
          Event Count
        </text>
        <g id="scale" transform="translate(15,18)">
          <g transform={`translate(18,10)`}>
            <circle
              clipPath="url(#middle-rect)"
              className="scale-legend-circle"
              r={props.sizeScale.range()[0]}
            />
            <text className="scale-legend-label" transform={`translate(25,4)`}>
              {props.sizeScale.domain()[0]}
            </text>
          </g>
          <g transform={`translate(18,25)`}>
            <circle
              clipPath="url(#middle-rect)"
              className="scale-legend-circle"
              r={props.sizeScale.range()[1]/2}
            />
            <text className="scale-legend-label" transform={`translate(25,4)`}>
            {Math.round(props.sizeScale.domain()[1]/2)}
            </text>
          </g>
          <g transform={`translate(18,40)`}>
            <circle
              clipPath="url(#middle-rect)"
              className="scale-legend-circle"
              r={props.sizeScale.range()[1]}
            />
            <text className="scale-legend-label" transform={`translate(25,4)`}>
            {props.sizeScale.domain()[1]}
            </text>
          </g>
        </g>
      </svg>
      <svg
        width={colourLegendWidth}
        height={85}
        style={{
          position: "absolute",
          left: legendWidth,
          transform: "translate(-100%,0)",
        }}
      >
        <defs>
          <clipPath id="middle-rect">
            <rect x="-50" y="-6" width="100" height="12" />
          </clipPath>
        </defs>
        <g id="color">
          {props.eventTypes.map((eventType, index) => {
            return (
              <g key={index} transform={`translate(0,${index * 18})`}>
                <circle
                  fill={props.colourScale(eventType)}
                  stroke="#fff"
                  strokeWidth={0.5}
                  r={7}
                  cx={15}
                  cy={10}
                />
                <text
                  transform={`translate(28,14)`}
                  style={{ fontSize: "0.7em", fill: "white" }}
                >
                  {eventType}
                </text>
              </g>
            );
          })}
        </g>
      </svg>
    </div>
  );
};

export default Legend;
